import { createSelector } from 'reselect';
import get from 'lodash/get';
import { initialState } from './reducer';
import { selectAppDomain } from '../App/selectors';
import { createSelectFieldOptions } from '../../utils/common';

const selectVenuesDomain = state => state.Venues || initialState;

const selectAggregationVenuesListOptions = (withAllData = false) =>
  createSelector(selectAppDomain, subState => {
    const venues = get(subState, 'aggregations.id', []);
    return createSelectFieldOptions(venues, 'id', 'name', {}, withAllData);
  });

export { selectVenuesDomain, selectAggregationVenuesListOptions };
